import React from 'react';
import { Box } from '@mui/material';
import useEagerAuditImage from '../hooks/useEagerAuditImage';

/**
 * Eager-load an audit recognition image (modals, tooltips, timelines).
 */
const AuditImg = ({
  auditId,
  alt = '',
  anonymousImage = '/anonymous.webp',
  sx = {},
  imgSx = {},
  enabled = true,
  ...boxProps
}) => {
  const { url } = useEagerAuditImage(auditId, enabled && Boolean(auditId));
  const src = url === undefined ? anonymousImage : (url || anonymousImage);

  return (
    <Box sx={sx} {...boxProps}>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          ...imgSx,
        }}
      />
    </Box>
  );
};

export default AuditImg;
